'use strict';

var a = 0;

function resizeWindow() {
	var theight = $(window).height() - 120;
	if ($('#home .top-content').height() > theight) {
		//$('#home .top-content').height(theight);
	} else {
			//$('#home .top-content').css('height','auto');
		}

	if ($(window).width() < 1090) {
		//Toggle open/close on tap
		$('#primary-nav li a').click(function (e) {
			if ($(this).next('.submenu').length > 0) {
				e.preventDefault();
				$('#primary-nav ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');

				if (!$(this).next('.submenu').hasClass('menu-open')) {
					$('.submenu.menu-open').slideUp(300, 'easeOutQuart').removeClass('menu-open');
					$(this).next().addClass('menu-open').slideDown(300, 'easeOutQuart');
				} else {
					$(this).next('.submenu').slideUp(300, 'easeOutQuart').removeClass('menu-open');
				}
			}
		});
		if ($(window).width() < 900) {
			$('.home-reasons .reason').each(function () {
				$(this).find('.text').insertAfter($(this).find('.image'));
			});
			$('#content #bottom-content .content-box .text h2').insertBefore($('#content #bottom-content .content-box .image'));
			$('#content #bottom-content .intro .text .hotelicon').insertAfter($('#content #bottom-content .intro .image'));
			$('.toset').insertAfter($('.intro .image'));
		} else {
			$('.home-reasons .reason').each(function () {
				$(this).find('.text').insertBefore($(this).find('.image'));
			});
			$('#content #bottom-content .content-box .text h2').insertBefore($('#content #bottom-content .content-box .text .col-md-6:first-child'));
			$('#content #bottom-content .intro .hotelicon').appendTo($('#content #bottom-content .intro .text'));
			$('.toset').insertAfter($('.intro .text p'));
		}
	} else {
		$('.toset').insertAfter($('.intro .text p'));
	}
}
function scrollDown() {
	var top = $(document).scrollTop();
	if (top > 0) {} else {}
	if ($('.booking-widget').hasClass('open')) {
		$('.booking-widget').removeClass('open').slideUp();
	}

	//home number animations
	if ($('.counter-value').length > 0) {
		var oTop = $('#numbers').offset().top - window.innerHeight;
		if (a == 0 && $(window).scrollTop() > oTop) {
			$('.counter-value').each(function () {
				var $this = $(this),
				    countTo = $this.attr('data-count');
				$({
					countNum: $this.text()
				}).animate({
					countNum: countTo
				}, {

					duration: 2600,
					easing: 'swing',
					step: function step() {
						$this.text(Math.floor(this.countNum));
					},
					complete: function complete() {
						$this.text(this.countNum);
						//alert('finished');
					}

				});
			});
			a = 1;
		}
	}
}

$(document).ready(function () {

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
	});

	$('.burger, .close-nav').click(function () {
		$('.main-menu').toggleClass('open');
	});

	// Main Nav Dropdown
	$('.special-btn').hover(function () {
		$(this).children('.overlay-box').fadeToggle('400');
	});
	$('.home-properties .home-prop-item').hover(function () {
		$(this).children('.overlay-box').fadeToggle('400');
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});
	$('.more-special').click(function (e) {
		e.preventDefault();

		// $('.view-more-content').slideUp();

		$(this).prev().slideToggle();
		$(this).toggleClass('read-less');

		if ($(this).hasClass('read-less')) {
			$(this).html('View Less -');
		} else {
			$(this).html('View More +');
		}
	});

	$('.more-terms').click(function (e) {
		e.preventDefault();

		// $('.view-more-content').slideUp();

		$(this).prev().slideToggle();
		$(this).toggleClass('read-less');

		if ($(this).hasClass('read-less')) {
			$(this).html('Close');
		} else {
			$(this).html('Terms & Conditions');
		}
	});
	//go to item
	var pathname = window.location.href;
	if (pathname.indexOf("#") != -1) {

		var urlpage = pathname.split("#");
		var rtarget = $('#' + urlpage[1]).offset().top + -120;
		$('body, html').animate({ scrollTop: rtarget }, 800, 'easeOutExpo');
	}

	//Remove empty <p> tags created by tinymce
	$('p').each(function () {
		var $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
	});

	if ($('#home').length > 0) {
		$('#home .main-content .home-map .list ul li').click(function () {
			$('#home .main-content .home-map .list ul li').removeClass('active');
			$(this).addClass('active');
		});
	}

	//btn effect
	//$('.btn').wrapInner('<span></span>');

	//header animation
	setTimeout(function () {
		$('header a.logo, header #primary-nav, header .book-btn').addClass('shown');
	}, 200);

	//Booking
	$('.book-btn .btn').click(function () {
		$('.booking-widget').addClass('open').slideDown();
	});
	$('.close-booking').click(function () {
		$('.booking-widget').removeClass('open').slideUp();
	});

	//Event Tracking
	//this class should be add to any link to the booking engine
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	//this class should be add to the header widget submit button
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});
	//this class should be add to any link to the visit website button
	$('.visit-website').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'portfolio website', 'click', 'visit website');
	});
	//this class should be add to any link to the contact us submit button
	$('.js-contact-us').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'contact', 'click', 'contact us');
	});
	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	$('.readmore').click(showMore);

	//forms label
	$('#job-form .form-entry').each(function () {
		var current = $(this).find('label').html();
		$(this).find('label').next().attr('placeholder', current);
	});

	$('form .btn.btnSubmit').click(function () {
		setTimeout(function () {
			$('p#thankyou').fadeOut(500);
		}, 6000);
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	$('body.interactive-map #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	//remove sitemap title and add it to the header
	if ($('body.sitemap').length > 0) {
		$('#top-content .top-header').hide();
	}

	//bars 
	$('header .bars').click(showMenu);

	$('.toset').click(function () {
		$('.hidden-form').fadeIn();
	});

	//tel link
	$('.tel').each(function () {
		var newTel = $(this).html().replace(/\D/g, '');
		$(this).attr('href', 'tel:' + newTel);
	});

	//Form select
	$('#formRFP #type_of_event').on('change', function () {
		$('#formRFP #sendto').attr('value', this.value);
	});

	//remove attributes
	$('#third-nav').removeAttr('aria-labelledby');
});

$(window).on('load', function () {
	resizeWindow();
	scrollDown();
	equalize();
	//Slick Slider
	$('.sym-slides').slick();
});

function showMore() {
	$(this).addClass('open');
	$(this).next().slideDown();
	$(this).unbind('click');
	$(this).click(hideMore);
}
function hideMore() {
	$(this).removeClass('open');
	$(this).next().slideUp();
	$(this).unbind('click');
	$(this).click(showMore);
}
function showMenu() {
	$(this).addClass('open');

	var wheight = $(window).height() - 120;
	$('header #primary-nav').height(wheight);

	if (!$('header #primary-nav').hasClass('open')) {
		$('header #primary-nav').wrapInner('<div class="block"></div>');
		$('header #primary-nav').addClass('open');
	}

	$('header #primary-nav').fadeIn();

	$(this).unbind('click');
	$(this).click(hideMenu);
}
function hideMenu() {
	$(this).removeClass('open');
	$('header #primary-nav').fadeOut();
	$(this).unbind('click');
	$(this).click(showMenu);
}
function navisEmailSignup(formID) {
	$.post(site_url + 'ajax/emailsignup.php', $("#" + formID).serialize(), function (data) {
		if (data.error) {
			if (formID == 'email-signup2') {
				$("#email-error2").html(data.msg);
			} else {
				$("#email-error").html(data.msg);
			}
		} else {
			$("#" + formID).html('<p>Thank You</p>');
		}
	}, 'json');
}